export default {
  LOAD_MY_CLAIMS_LIST_PAGE_START: 'LoadMyGeneralCompetencyClaimsListPageStart',
  LOAD_MY_CLAIMS_LIST_PAGE_END: 'LoadMyGeneralCompetencyClaimsListPageEnd',
  SELECT_MY_CLAIM: 'SelectMyGeneralCompetencyClaim',
  TOGGLE_DELETE_CLAIM_DIALOG: 'ToggleDeleteMyGeneralCompetencyClaimDialog'
};
